import React from 'react';

import { translate } from '../../../../core/scripts/chart-components/utils';

const months = ['Jan.', 'Feb.', 'März', 'April', 'Mai', 'Juni', 'Juli', 'Aug.', 'Sept.', 'Okt.', 'Nov.', 'Dez.'];
const getReadableDate = millis => {
  const date = new Date(millis);
  return `${months[date.getMonth()]} ${date.getFullYear()}`;
};

export default ({ x, height, margin, xScale }) => {
  if (!x) {
    return null;
  }

  return (
    <g transform={translate(x, 0)}>
      <line
        className="chart__mouseline"
        x1={0}
        x2={0}
        y1={20}
        y2={height - margin.top}
      />
      <rect
        className="chart__mouserect"
        width={62}
        height={15}
        x={-31}
        y={5}
        rx={2}
      />
      <text
        className="chart__mousetext"
        x={0}
        y={16}
        textAnchor="middle"
      >
        {getReadableDate(xScale.invert(x))}
      </text>
    </g>
  );
}
